<template>
  <div class="new_user_top" style="background: #FFFFFF;">
    <div class="nut">
      <div class="nut_logo">
        <router-link to="/"><img src="../assets/img/shiyan_logo.jpg" title="欢迎访问进入个人学习中心！"/></router-link>
      </div>
      <div class="nut_user">
        <div class="nutu_user">{{ userInfo.realName }}
          <div class="nutuu_disk">
            <div class="nutuud_top">
              <div class="nutuud_top_left"><img :src="userInfo.imageUrl"/></div>
              <div class="nutuud_top_right">
                <p>{{ userInfo.realName }}</p>
                <p :title="userInfo.company.companyName">{{ userInfo.company.companyName }}</p>
              </div>
            </div>
            <div class="nutuud_fastlink">
              <router-link :to="{ path: '/EditUser', query: { baseVisible: true }}">帐号设置</router-link>
              <router-link :to="{ path: '/EditUser', query: { pwdVisible: true }}">修改密码</router-link>
              <!--<a href="#">我的培训</a>-->
            </div>
          </div>
        </div>
        <a class="nutu_bind" href="javascript:" @click="showLearnCardBind=true">绑定学习卡</a>
        <a class="nutu_exit" href="javascript:" @click="logout">退出</a>
      </div>
      <learnCardBind :value.sync="showLearnCardBind"></learnCardBind>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import shortcut from '../components/Shortcut'
import learnCardBind from '../components/LearnCardBind'
import { FaceRecognitionStorage } from '../utils/global-methods'
import Cookies from 'js-cookie'

export default {
  components: {
    shortcut,
    learnCardBind
  },
  data() {
    return {
      showUserMenu: false,
      showLearnCardBind: false
    }
  },
  computed: {
    ...mapGetters([
      'userInfo'
    ])
  },
  methods: {
    ...mapActions([
      'userLogout'
    ]),
    logout() {
      // this.userLogout()
      // this.$router.push("/")
      localStorage.removeItem(`${ this.userInfo.uuid }_pw_weak`) //清除弱密码标记
      FaceRecognitionStorage.delFRSData()
      Cookies.remove(`${ this.userInfo.uuid }_self_verified`)
      this.userLogout()
      if (this.$route.path === '/') {
        this.$router.go(0)
      } else {
        window.location.href = window.location.origin
      }
    }
  }
}
</script>

<style scope>

</style>



// WEBPACK FOOTER //
// src/components/Header3.vue